import { Component,
         OnInit }                 from '@angular/core';
import { MatDialogRef }            from '@angular/material';
import { SortableFilter } from '../common/sortable-filter';
import { SettingService } from '../shared/setting.service';
import { Globals }                from './../common/globals';
import { CompanyModel }           from './../company-list/company.model';

@Component({
  selector: 'sa-company-dialog',
  template: require('./company-dialog.component.html'),
  styles: [require('./company-dialog.component.scss')]
})
export class CompanyDialogComponent implements OnInit {

  public newItem = false;
  public model: CompanyModel;
  public logoUrl: string;
  public antiCache: string;

  private errors = Array<string>();

  public currencyIsoCodes = [];

  public countryIso2Codes = ['CZ', 'SK', 'AT', 'HU']; // fallback, by default loaded from setting, key 'availableCountries'

  public languages = ['cs-CZ', 'sk-SK', 'hu-HU']; // fallback, by default loaded from setting, key supportedLanguages

  public businessTypes = [
      {id: 1, name: 'Vlak'},
      {id: 2, name: 'Bus'}
  ];

  constructor(
    public dialogRef: MatDialogRef<CompanyDialogComponent>, 
    public globals: Globals, 
    private settingsService: SettingService) {
    this.antiCache = new Date().getTime() + '';
  }

  delete() {
    if (confirm('Opravdu si přejete odstranit tento záznam?\nTato změna je nevratná.')) {
      this.dialogRef.close('delete');
    }
  }

  public imageUploaded(file) {
    this.model.newImage = file;
  }

  public certUploaded(file) {
    this.model.newCert = file;
  }

  ngOnInit() {
    this.logoUrl = this.globals.GetUrlPrefix() +  '/api/company/getlogo/' + this.model.companyUid;

    let allowedCurrenciesFilter: SortableFilter = { searchString: 'allowedCurrencies' } as SortableFilter;

    this.settingsService.getItems(allowedCurrenciesFilter)
                            .subscribe(currencies => {
                              if(!!currencies && currencies.length > 0) {
                                this.currencyIsoCodes = currencies[0].value.split(',');
                              }
                            });

    let availableCountries: SortableFilter = { searchString: 'availableCountries' } as SortableFilter;

    this.settingsService.getItems(availableCountries)
                            .subscribe(countries => {
                              if(!!countries && countries.length > 0) {
                                this.countryIso2Codes = countries[0].value.split(',');
                              }
                            });

    let allowedLanguagesFilter: SortableFilter = { searchString: 'supportedLanguages' } as SortableFilter;
    this.settingsService.getItems(allowedLanguagesFilter)
                            .subscribe(langs => {
                              if(!!langs && langs.length > 0) {
                                this.languages = langs[0].value.split(',');
                              }
                            });
  }

  save() {
    this.errors = [];
    if (!this.model.name || this.model.name.length === 0) {
        this.errors.push('Zadejte prosím jmého daňového subjektu');
    }
    if (!this.model.companyName || this.model.companyName.length === 0) {
        this.errors.push('Zadejte prosím jmého firmy daňového subjektu');
    }
    if (!this.model.companyLin || this.model.companyLin.length === 0) {
        this.errors.push('Zadejte prosím IČ');
    }
    if (!this.model.companyTin || this.model.companyTin.length === 0) {
        this.errors.push('Zadejte prosím DIČ');
    }
    if (!this.model.currencyIsocode || this.model.currencyIsocode.length === 0) {
        this.errors.push('Zadejte prosím měnu');
    }
    if (!this.model.countryIso2code || this.model.countryIso2code.length === 0) {
        this.errors.push('Zadejte prosím zemi');
    }
    if (!this.model.street || this.model.street.length === 0) {
        this.errors.push('Zadejte prosím ulici');
    }
    if (!this.model.houseNumber || this.model.houseNumber.length === 0) {
        this.errors.push('Zadejte prosím číslo popisné');
    }
    if (!this.model.city || this.model.city.length === 0) {
        this.errors.push('Zadejte prosím město');
    }
    if (!this.model.zipCode || this.model.zipCode.length === 0) {
        this.errors.push('Zadejte prosím PSČ');
    }

    if (this.errors.length === 0) {
      this.dialogRef.close('save');
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/company-dialog/company-dialog.component.ts